export default __webpack_public_path__ + "static/media/r11.4908ded1.jpg";